// extracted by css-extract-rspack-plugin
export default {"selectedTierOptionCard":"BTDJD"};